import * as sharedTypes from 'src/actions/shared/sharedTypes';

import topicsResource from './topicsResource';
import topicsHierarchyResource from './topicsHierarchyResource';
import { sortMergedTopics } from './topicsUtils';

const fetchTopicsAndHierarchies: sharedTypes.AppThunk = () => async (dispatch, getState) => {
  dispatch(topicsResource.actions.dataMergeStarted({}));

  await Promise.all([
    dispatch(topicsResource.effects.fetchAll()),
    dispatch(topicsHierarchyResource.effects.fetchAll()),
  ]);

  const state = getState();

  if (state.topics.loadingState === 'succeeded' && state.topicsHierarchy.loadingState === 'succeeded') {
    const topics = sortMergedTopics(state);
    dispatch(topicsResource.actions.dataMergeFinished(topics));
  }
};

export default fetchTopicsAndHierarchies;
